module.exports = __webpack_public_path__ + "static/img/inverted-inner-corner-quarter-pipe_256.40b9b87.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/inverted-inner-corner-quarter-pipe_256.png
// module id = Qi1K
// module chunks = 0